import { ApiResponse } from "../../../types/ApiResponse";
import api from "../../../utils/API";
import { TenantDTO } from "../dto";
import { Tenant } from "../entity";

export const getTenant = (): ApiResponse<Tenant[]> => api.get("/v1/tenants");
export const postTenant = (params: TenantDTO) =>
  api.post("/v1/tenants", params);
export const deleteTenant = (id: string): ApiResponse<{ message: boolean }> =>
  api.delete(`/v1/tenants/${id}`);
export const getTenantById = (id: number): ApiResponse<Tenant> =>
  api.get(`/v1/tenants/${id}`);
